<template>
	<div>
		<b-row>
			<b-col cols="12" class="mb-3 mt-3">
				<h4>Attend on site</h4>
			</b-col>


			<b-col>
				<b-col><h5>There are no tasks in this section</h5></b-col>
				<div
					class="rounded border primary mt-1 mb-1 py-2 task-push--static"
					id="popover-0-0"
				>
					
					<b-row>
						
						<b-col>
							<b-button
								size="sm"
								@click.prevent="addTask(1, -1, 0)"
								variant="light"
								class="float-right mr-3"
								>+ Task</b-button
							>
							<b-button
								size="sm"
								@click.prevent="addTask(2, -1, 0)"
								class="float-right mr-3"
								variant="light"
								>+ Check-out</b-button
							>
							<b-button
								size="sm"
								@click.prevent="addTask(0, -1, 0)"
								class="float-right mr-3"
								variant="light"
								>+ Check-in</b-button
							>
						</b-col>
					</b-row>
				</div>

				<b-popover
					target="popover-0-0"
					triggers="hover"
					placement="right"
					variant="light"
				>
					<b-icon
						font-scale="1.5"
						animation="cylon"
						icon="arrow-left"
					></b-icon>
				</b-popover>

			</b-col>
		</b-row>
		<b-row>
			<b-col cols="12" class="mb-3 mt-3">
				<h4>In our workshop</h4>
			</b-col>

			<b-col>
				<b-col><h5>There are no tasks in this section</h5></b-col>
				<div
					class="rounded border primary mt-1 mb-1 py-2 task-push--static"
					id="popover-1-0"
				>
					<b-row>
						<b-col>
							<b-button
								size="sm"
								@click.prevent="addTask(1, -1, 1)"
								variant="light"
								class="float-right mr-3"
								>+ Task</b-button
							>
						</b-col>
					</b-row>
				</div>
				<b-popover
					target="popover-1-0"
					triggers="hover"
					placement="right"
					variant="light"
				>
					<b-icon
						font-scale="1.5"
						animation="cylon"
						icon="arrow-left"
					></b-icon>
				</b-popover>

			</b-col>
		</b-row>
		<b-row>
			<b-col cols="12" class="mb-3 mt-3">
				<h4>Return to site</h4>
			</b-col>

			<b-col>
				<b-col><h5>There are no tasks in this section</h5></b-col>
				<div
					class="rounded border primary mt-1 mb-1 py-2 task-push--static"
					id="popover-2-0"
				>
					<b-row>
						<b-col>
							<b-button
								size="sm"
								@click.prevent="addTask(1, 0, 2)"
								variant="light"
								class="float-right mr-3"
								>+ Task</b-button
							>
						</b-col>
					</b-row>
				</div>
				<b-popover
					target="popover-2-0"
					triggers="hover"
					placement="right"
					variant="light"
				>
					<b-icon
						font-scale="1.5"
						animation="cylon"
						icon="arrow-left"
					></b-icon>
				</b-popover>

			</b-col>
		</b-row>
	</div>
</template>

<script>
import AccountService from "@/api-services/account.service";
import AssignmentService from "@/api-services/assignment.service";

export default {
	name: "JobTaskListEmpty",

	// things we have inherited from our parent
	props: ["jobId", "assignments"],

	components: {},

	mounted() {
		//this.packTasks();

		this.fetchEngineers();
	},

	// data we bind to, components need a function wrapping this all up, to keep instances seperate
	data() {
		return {
			taskTypes: [[], [], []],

			engineers: [],
			materials: [],

			creating: false,

			addingType: null,
			addingNote: null,

			modalContent: null,
			modalTitle: "Select",
		};
	},

	methods: {
		fetchEngineers() {
			AccountService.getAll()
				.then((response) => {
					this.engineers = response.data;
				})
				.catch((error) => {
					console.log("not authorized");
				});
		},

		fetchMaterials() {
			MaterialService.getAll()
				.then((response) => {
					this.materials = response.data;
				})
				.catch((error) => {
					console.log("not authorized");
				});
		},

		packTasks() {
			this.assignments.forEach((assignment) => {
				this.$set(assignment, "Open", false);
				this.taskTypes[assignment.TaskType].push(assignment);
			});

			this.taskTypes.forEach((tasks) => {
				tasks.sort((a, b) =>
					a.Order > b.Order ? 1 : b.Order > a.Order ? -1 : 0
				);
			});
		},

		editSection(section) {
			this[section] = true;
		},

		updateTasks() {
			let cloneBlocks = JSON.parse(JSON.stringify(this.taskTypes));
			let flattened = cloneBlocks.flat(2);
			this.$emit("updateJobTasks", flattened, true);
		},

		addTask(taskType, prevIndex, taskSubType) {
			let taskTitle = "New task";
			if (taskSubType == 0) {
				taskTitle = "Check in";
			} else if (taskSubType == 2) {
				taskTitle = "Check out";
			}

			let newTask = {
				JobId: this.jobId,
				TaskType: taskType,
				TaskSubType: taskSubType,
				Title: taskTitle,
				Hours: 0,
				Scheduled: null,
				Completed: null,
				SignedOff: false,
				Open: false,
				Order: prevIndex + 1,
			};

			let vm = this;
			// save to database
			AssignmentService.create(newTask)
				.then((res) => {
					newTask.Id = res.data.Id;

					this.creating = true;

					vm.taskTypes[taskType].splice(prevIndex + 1, 0, newTask);

					this.setTaskOrder();

					this.$nextTick(() => {
						vm.$root.$emit(
							"bv::toggle::collapse",
							"collapse-" + taskType + "-" + newTask.Order
						);

						this.creating = false;
					});
				})

				.catch((error) => {
					this.$emit("handleError", error.response.data);
				});
		},

		setTaskOrder() {
			this.taskTypes.forEach((tasks) => {
				tasks.forEach((task, i) => {
					task.Order = i;
				});
			});

			this.updateTasks();
		},
	},
};
</script>


// WEBPACK FOOTER //
// src/components/job/job-task-list-empty.vue